/**
 * Virtual browse state per expanded indicator (Arrow detail); not stored in Redux.
 */

export type BuilderArrowDimWindow = {
  parentId: number;
  indicatorName: string;
  totalCount: number;
  /** Index of first materialised dim tuple in the Arrow table for this indicator. */
  startIndex: number;
};

const windowsByParentId = new Map<number, BuilderArrowDimWindow>();

export function setBuilderArrowDimWindow(window: BuilderArrowDimWindow): void {
  windowsByParentId.set(window.parentId, window);
}

export function getBuilderArrowDimWindow(parentId: number): BuilderArrowDimWindow | undefined {
  return windowsByParentId.get(parentId);
}

export function clearBuilderArrowDimWindow(parentId: number): void {
  windowsByParentId.delete(parentId);
}

export function clearAllBuilderArrowDimWindows(): void {
  windowsByParentId.clear();
}

export function listBuilderArrowDimWindows(): BuilderArrowDimWindow[] {
  return Array.from(windowsByParentId.values());
}

/**
 * Register or refresh window metadata when a parent chevron expands.
 */
export function initBuilderArrowDimWindow(
  parentId: number,
  indicatorName: string,
  totalCount: number,
): BuilderArrowDimWindow {
  const window: BuilderArrowDimWindow = {
    parentId,
    indicatorName,
    totalCount,
    startIndex: 0,
  };
  setBuilderArrowDimWindow(window);
  return window;
}

export function updateBuilderArrowDimStartIndex(
  parentId: number,
  startIndex: number,
): BuilderArrowDimWindow | undefined {
  const existing = getBuilderArrowDimWindow(parentId);
  if (!existing) return undefined;
  const maxStart = Math.max(0, existing.totalCount - 1);
  const clamped = Math.min(Math.max(0, startIndex), maxStart);
  const updated = { ...existing, startIndex: clamped };
  setBuilderArrowDimWindow(updated);
  return updated;
}
